const state = {
  module: null,
  page: null,
  activeModule: '',
  profileDialog: false,
  isNavigationDrawerDisplayed: false,
}

export default state
